import React, { Fragment, useState, useEffect } from "react";

//package import

import {
  // AppBar,
  Toolbar,
  IconButton,
  Box,
  Menu,
  MenuItem,
  TextField,
  useTheme,
  Badge,
  Typography,
  Stack,
  Button,
  Backdrop,
  CircularProgress,
  Alert,
  Snackbar,
  Avatar,
} from "@mui/material";
import {
  Menu as MenuIcon,
  AccountCircle,
  Search as SearchIcon,
} from "@mui/icons-material";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import NotificationsSharpIcon from "@mui/icons-material/NotificationsSharp";
import { useNavigate, useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { useDecodedToken } from "../../Services/Routes/App/PrivateRouts";
import {
  AdminUsersICon,
  AdminWalletICon,
  AdminTransactionsICon,
  AdminPaymentGatewaysICon,
  AdminServiceProviderICon,
  DollarIcon,
  SuccessIcon,
  ModalSpinner,
  AdminToggleActiveIcon,
  AdminToggleInActiveIcon,
} from "../../Svg";
import { USER_ROLES_ENUM } from "../../Services/Enums";
import AddIcon from "@mui/icons-material/Add";
import { AdminFormModal } from "../../components";
import { createUserInAdmin } from "../../../src/Services/validation/AdminUser";
import { headersPost } from "../../Services/API";
import { AdminUrls } from "../../Services/Routes/API";
import { MainRoutes } from "../../Services/Routes/App";
import { GATEWAY_ENUM, SERVICE_PROVIDER_ENUM } from "../../Services/Enums";

//component

function Topbar({ handleDrawerToggle }) {
  //hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const user = useDecodedToken();
  const location = useLocation();

  let resourcevariable;

  const navEl = document.getElementsByTagName("nav");

  let navigationsArray = location?.pathname?.replace("-", " ");
  let navTittle = navigationsArray?.split("/") || [];

  navTittle?.reverse().pop();
  // let navTittle = navigationsArray?.replace(/(?:.*?\/){2}/, "");
  const urlNavPoints = navTittle;
  const urlEndingPoint = urlNavPoints[0];
  urlNavPoints?.reverse();

  const urlStartPoint = urlNavPoints[0];

  //states

  const [anchorEl, setAnchorEl] = useState(null);
  const [topBarIcon, setTopBarIcon] = useState();
  const [topBarText, setTopBarText] = useState("");
  const [addUserBtn, setAddUserBtn] = useState(false);
  const [addPaymentBtn, setAddPaymentBtn] = useState(false);
  const [addProviderBtn, setAddProviderBtn] = useState(false);
  const [createUserModal, setCreateUserModal] = useState(false);
  const [addPaymentMethodModal, setAddPaymentMethodModal] = useState(false);
  const [addServiceProviderModal, setAddServiceProviderModal] = useState(false);
  const [headerWidth, setHeaderWidth] = useState(0);
  const [navWidth, setNavWidth] = useState(0);
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [profileIcon, setProfileIcon] = useState(false);
  const [searchBar, setSearchBar] = useState(false);

  //functions

  // Create User Modal

  const Form_Modal_List_For_Create_User = [
    {
      formKey: "user",
      name: "first_name",
      label: "First Name",
    },
    {
      formKey: "user",
      name: "last_name",
      label: "Last Name",
    },
    {
      formKey: "user",
      name: "email",
      label: "Enter Email",
    },
  ];
  const Form_Modal_Buttons_For_Create_User = [
    {
      text: "Create",
      name: "create",
      type: "submit",
      style: {
        backgroundColor: "#11A1EC",
        width: "100%",
        borderRadius: "1",
        padding: "1.5",
      },
    },
  ];

  // Add Payment Method Modal

  const Form_Modal_List_For_Add_Payment_Method = [
    {
      formKey: "payment_gateway",
      name: "bank_name",
      label: "Bank",
      style: { paddingY: 0.5, fontSize: 4 },
    },

    {
      formKey: "payment_gateway",
      name: "main_type",
      label: "Gateway",
      type: "select",
      options: GATEWAY_ENUM,
      style: { paddingY: 0.5, fontSize: 4 },
    },
    {
      formKey: "payment_gateway",
      name: "client_secret",
      label: "Client Secret Key",
      style: { paddingY: 0.5, fontSize: 4 },
    },
    {
      formKey: "payment_gateway",
      name: "client_id",
      label: "Client Id",
      style: { paddingY: 0.5, fontSize: 4 },
    },
    {
      formKey: "payment_gateway",
      name: "monthly_limit",
      label: "Monthly Transaction Limit",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },
    {
      formKey: "payment_gateway",
      name: "daily_limit",
      label: "Daily Transaction Limit",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },

    {
      formKey: "payment_gateway",
      name: "average_ticket",
      label: "Avg Transaction Limit",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },
    {
      formKey: "payment_gateway",
      name: "monthly_service_fee",
      label: "Service Fee",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },
    {
      formKey: "payment_gateway",
      value: false,
      type: "switch",
      name: "is_archived",
      label: "Active & Inactive",
      // status: true,
      handleChange: (e) => {},
    },
    {
      formKey: "payment_gateway",
      text: "Upload Logo",
      type: "file",
      name: "logo",
      style: {
        backgroundColor: "#FFA361",
        width: "40%",
        borderRadius: "1",
        padding: "1.5",
      },
    },
  ];

  const Form_Modal_Button_For_Add_Payment_Method = [
    {
      formKey: "payment_gateway",
      text: "+ Add Payment Gateway",
      name: "add_payment_gateway",
      type: "submit",
      style: {
        backgroundColor: "#11A1EC",
        width: "100%",
        borderRadius: "1",
        padding: "1.5",
        marginBottom: "1rem",
      },
    },
  ];

  // Add Service Provider Modal

  const Form_Modal_List_For_Add_Service_Provider = [
    {
      formKey: "service_provider",
      name: "name",
      label: "Name",
      style: { paddingY: 0.5, fontSize: 4 },
    },

    {
      formKey: "service_provider",
      name: "sub_type",
      label: "Service Provider",
      type: "select",
      options: SERVICE_PROVIDER_ENUM,
      style: { paddingY: 0.5, fontSize: 4 },
    },
    {
      formKey: "service_provider",
      name: "client_secret",
      label: "Client Secret Key",
      style: { paddingY: 0.5, fontSize: 4 },
    },
    {
      formKey: "service_provider",
      name: "client_id",
      label: "Client Id",
      style: { paddingY: 0.5, fontSize: 4 },
    },
    {
      formKey: "service_provider",
      name: "monthly_limit",
      label: "Monthly Transaction Limit",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },
    {
      formKey: "service_provider",
      name: "daily_limit",
      label: "Daily Transaction Limit",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },

    {
      formKey: "service_provider",
      name: "average_ticket",
      label: "Avg Transaction Limit",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },
    {
      formKey: "service_provider",
      name: "monthly_service_fee",
      label: "Service Fee",
      icon: <DollarIcon />,
      style: {
        paddingY: 0,
        paddingLeft: 0,
        margin: "4px",
        fontSize: 4,
        width: "47%",
      },
      style1: {
        display: "flex",
        justifyContent: "center",
        width: 25,
        height: 25,
        bgcolor: "#C4C4C4",
        borderRadius: 1,
      },
    },
    {
      formKey: "service_provider",
      value: false,
      type: "switch",
      name: "is_archived",
      label: "Active & Inactive",
      // status: true,
      // handleChange: (e) => {},
    },
    {
      formKey: "service_provider",
      text: "Upload Logo",
      type: "file",
      name: "logo",
      style: {
        backgroundColor: "#FFA361",
        width: "40%",
        borderRadius: "1",
        padding: "1.5",
      },
    },
  ];

  const Form_Modal_Button_For_Add_Service_Provider = [
    {
      formKey: "service_provider",
      text: "+ Add Service Provider",
      name: "add_service_provider",
      type: "submit",
      style: {
        backgroundColor: "#11A1EC",
        width: "100%",
        borderRadius: "1",
        padding: "1.5",
        marginBottom: "1rem",
      },
    },
  ];

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const userModalHandlerClose = () => {
    setCreateUserModal(false);
    setAddPaymentMethodModal(false);
    setAddServiceProviderModal(false);
  };
  useEffect(() => {
    switch (user.role) {
      case "admin":
        if (urlEndingPoint === "wallets") {
          setTopBarIcon(<AdminWalletICon />);
          setTopBarText("All wallets listings");
          setAddPaymentBtn(false);
          setAddUserBtn(false);
          setAddProviderBtn(false);
        } else if (urlEndingPoint === "transactions") {
          setTopBarIcon(<AdminTransactionsICon />);
          setTopBarText("All transactions by users");
          setAddPaymentBtn(false);
          setAddUserBtn(false);
          setAddProviderBtn(false);
        } else if (urlEndingPoint === "users") {
          setTopBarIcon(<AdminUsersICon />);
          setTopBarText("All Limospay users");
          setAddUserBtn(true);
          setAddPaymentBtn(false);
          setAddProviderBtn(false);
        } else if (urlEndingPoint === "payment gateways") {
          setTopBarIcon(<AdminPaymentGatewaysICon />);
          setTopBarText("All payment gateways");
          setAddPaymentBtn(true);
          setAddUserBtn(false);
          setAddProviderBtn(false);
        } else if (urlEndingPoint === "service providers") {
          setTopBarIcon(<AdminServiceProviderICon />);
          setTopBarText("All service providers");
          setAddProviderBtn(true);
          setAddPaymentBtn(false);
          setAddUserBtn(false);
        }

        break;
      case "user":
        if (urlEndingPoint === "dashboard") {
          setProfileIcon(true);
          setSearchBar(true);
        } else if (urlEndingPoint === "wallet") {
          setSearchBar(true);
          setProfileIcon(false);
        } else if (urlEndingPoint === "transaction") {
          setProfileIcon(false);
          setSearchBar(true);
        } else {
          setProfileIcon(false);
          setSearchBar(false);
        }

        break;
      default:
    }
  }, [urlStartPoint, urlEndingPoint]);

  const createUserHandler = (data) => {
    setOpen(true);
    headersPost(AdminUrls?.CREATE_USER, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setCreateUserModal(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  // ADD Payment Gateway
  const addPaymentGatewayHandler = (data) => {
    setOpen(true);
    headersPost(AdminUrls?.ADD_PAYMENT_GATEWAY, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setAddPaymentMethodModal(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  // ADD Payment Gateway
  const addServiceProviderHandler = (data) => {
    setOpen(true);
    headersPost(AdminUrls?.ADD_SERVICE_PROVIDER, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setAddServiceProviderModal(false);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(MainRoutes?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //close alert

  const handleClosee = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  //render

  useEffect(() => {
    if (navEl) {
      const resizeWidth = () => {
        const NAV_WIDTH = navEl[0].offsetWidth;
        setNavWidth(NAV_WIDTH);
        setHeaderWidth(window.innerWidth - (NAV_WIDTH || 0));
      };

      if (navWidth === 0 && headerWidth === 0) {
        resizeWidth();
      }

      window.addEventListener("resize", resizeWidth);

      return () => window.removeEventListener("resize", resizeWidth);
    }
  }, [navEl]);

  return (
    <Fragment>
      <Box
        component={"header"}
        // elevation={0}
        sx={{
          width: headerWidth,
          padding: 0,
          position: "fixed",
          right: 0,
          top: 0,
          left: navWidth,
          zIndex: 99,
        }}
      >
        <Toolbar
          // elevation={1}
          display={"flex"}
          sx={{
            backgroundColor: "#fafafa",
          }}
        >
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={() => handleDrawerToggle()}
            sx={{
              mr: 2,
              display: { md: "none" },
              color: theme.palette.primary.main,
            }}
          >
            <MenuIcon />
          </IconButton>

          <Stack direction={"row"}>
            <Box>
              {user?.role?.includes(USER_ROLES_ENUM.admin) && (
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  height={47}
                  width={47}
                  borderRadius={1}
                  bgcolor={"#11A1EC"}
                >
                  {topBarIcon}
                </Box>
              )}
            </Box>
            <Box
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
            >
              <Typography
                variant="h6"
                width={"20vw"}
                sx={{
                  margin: { xs: "auto 0.1rem", sm: "auto 0.25rem" },
                  fontWeight: "bold",
                  color: theme.palette.text.light,
                  lineHeight: theme.spacing(1),
                  textTransform: "capitalize",
                }}
              >
                {urlEndingPoint}
              </Typography>
              <Typography
                sx={{
                  color: "#666666",
                  lineHeight: theme.spacing(1),
                  px: theme.spacing(1),
                }}
                variant="body2"
              >
                {topBarText}
              </Typography>
            </Box>
          </Stack>

          <Box
            display={"flex"}
            justifyContent={"left"}
            alignItems={"center"}
            width={"90%"}
          >
            {searchBar ? (
              <TextField
                size="small"
                type="search"
                placeholder="Search here"
                InputProps={{
                  startAdornment: (
                    <SearchIcon
                      sx={{
                        color: theme.palette.primary.dark,
                      }}
                    />
                  ),
                }}
                sx={{
                  borderRadius: 1,
                  backgroundColor: theme.palette.secondary.dark,
                  [`.${outlinedInputClasses.root}`]: {
                    borderRadius: 1,
                    paddingX: 2,
                  },
                }}
              />
            ) : null}
          </Box>
          {user?.role?.includes(USER_ROLES_ENUM.user) && (
            <Box paddingRight={2} display={"flex"} justifyContent={"flex-end"}>
              <Badge
                color="error"
                badgeContent="9"
                sx={{
                  backgroundColor: theme.palette.text.disabled,
                  borderRadius: theme.spacing(3),
                  height: theme.spacing(4),
                  width: theme.spacing(4),
                  alignItems: "center",
                  justifyContent: "center",
                  mr: 2,
                }}
              >
                <NotificationsSharpIcon fontSize="medium" />
              </Badge>
            </Box>
          )}
          {profileIcon ? (
            <Stack direction={"row"} spacing={1}>
              <Avatar />
              <Box
                display={"flex"}
                justifyContent={"center"}
                flexDirection={"column"}
                minWidth={120}
              >
                <Typography variant="body2"> {user.name} </Typography>
              </Box>
            </Stack>
          ) : null}
          {addUserBtn ? (
            <Box
              display={"flex"}
              alignItems={"center"}
              margin={{ xs: "auto 0.1rem", sm: "auto 0.25rem" }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  setCreateUserModal(true);
                }}
                sx={{
                  maxHeight: 40,
                  minHeight: 40,
                  maxWidth: 120,
                  minWidth: 120,
                  padding: 0.8,
                  backgroundColor: "#11A1EC",
                  display: { xs: `none`, sm: "flex" },
                }}
                startIcon={<AddIcon />}
              >
                Add User
              </Button>
            </Box>
          ) : null}

          {addPaymentBtn ? (
            <Box
              display={"flex"}
              alignItems={"center"}
              margin={{ xs: "auto 0.1rem", sm: "auto 0.25rem" }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  setAddPaymentMethodModal(true);
                }}
                sx={{
                  maxHeight: 40,
                  minHeight: 40,
                  maxWidth: 180,
                  minWidth: 180,
                  padding: 0.8,
                  backgroundColor: "#11A1EC",
                  display: { xs: `none`, sm: "flex" },
                }}
                startIcon={<AddIcon />}
              >
                Add Payment Method
              </Button>
            </Box>
          ) : null}
          {addProviderBtn ? (
            <Box
              display={"flex"}
              alignItems={"center"}
              margin={{ xs: "auto 0.1rem", sm: "auto 0.25rem" }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  setAddServiceProviderModal(true);
                }}
                sx={{
                  maxHeight: 40,
                  minHeight: 40,
                  maxWidth: 180,
                  minWidth: 180,
                  padding: 0.8,
                  backgroundColor: "#11A1EC",
                  display: { xs: `none`, sm: "flex" },
                }}
                startIcon={<AddIcon />}
              >
                Add Service Provider
              </Button>
            </Box>
          ) : null}

          <AdminFormModal
            open={createUserModal}
            onClose={userModalHandlerClose}
            modalPages={1}
            MainHeading={"Create New User"}
            TextFieldArray={Form_Modal_List_For_Create_User}
            ButtonsArray={Form_Modal_Buttons_For_Create_User}
            ValidationSchemaModals={createUserInAdmin}
            // initialFormData={""}
            onSubmit={createUserHandler}
          />
          <AdminFormModal
            open={addPaymentMethodModal}
            onClose={userModalHandlerClose}
            MainHeading={"Add Payment Gateway"}
            TextFieldArray={Form_Modal_List_For_Add_Payment_Method}
            ButtonsArray={Form_Modal_Button_For_Add_Payment_Method}
            // initialFormData={""}
            onSubmit={addPaymentGatewayHandler}
          />
          <AdminFormModal
            open={addServiceProviderModal}
            onClose={userModalHandlerClose}
            MainHeading={"Add Service Provider"}
            TextFieldArray={Form_Modal_List_For_Add_Service_Provider}
            ButtonsArray={Form_Modal_Button_For_Add_Service_Provider}
            // initialFormData={""}
            onSubmit={addServiceProviderHandler}
          />
        </Toolbar>
      </Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClosee}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClosee} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Fragment>
  );
}

export default Topbar;
